import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Box,
  IconButton,
} from "@mui/material";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";
import CloseIcon from "@mui/icons-material/Close";

function UnsavedChangesDialog({ open, onClose, onLeave }) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: "12px",
        },
      }}
    >
      <DialogTitle
        sx={{
          p: "12px 24px",
          borderBottom: "1px solid #dee2e6",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
          <h3 className="mb-0">Unsaved Changes</h3>
        </Box>
        <IconButton
          size="small"
          onClick={onClose}
          sx={{ color: "var(--bs-gray-700)" }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent className="pt-3" sx={{ p: 3 }}>
        <p style={{ marginBottom: 0 }}>
          You have unsaved changes on this page. If you leave now your filled
          data will be lost.
        </p>
      </DialogContent>

      <DialogActions sx={{ p: "12px 24px", borderTop: "1px solid #dee2e6" }}>
        <Button variant="outlined" onClick={onLeave}>
          Leave
        </Button>
        <Button variant="contained" onClick={onClose}>
          Stay on Page
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default UnsavedChangesDialog;
